// extracted by mini-css-extract-plugin
export default {"broken-widget":"ReportBlockBroken_broken-widget__53sDQ"};